import '@tabler/core/dist/js/tabler.min.js'
import '@tabler/icons-webfont/dist/tabler-icons.min.css'
import "regenerator-runtime/runtime"
import autosize from "autosize"
import { delegate as tippyDelegate } from 'tippy.js'
import webf, { dom, eventDispatcher } from "@webalternatif/js-core"
import { WebfDate } from "@webalternatif/js-date";
import 'tippy.js/dist/tippy.css'
import '@tabler/core/dist/css/tabler.css'
import '@fontsource-variable/inter'
import 'webf'
import $ from "jquery";
import '@fortawesome/fontawesome-free/css/all.min.css'
import '../styles/app.scss'
import { initSentry } from './sentry';

initSentry();

const appHeight = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}
// window.addEventListener('resize', appHeight)
dom.on(window, 'resize', appHeight)
appHeight()

eventDispatcher.addListener('webf.refresh', () => {
    /**
     * Dates
     */
    $('.smart-datetime').webfDatetimepicker({
        showMonthYear: true,
        format: 'dd/MM/yyyy HH:mm',
        date: new WebfDate().startOfHour().toDate(),
        timepicker: 'slider',
        onSelectDate: function() {
            $(this).trigger('change');
            $(this).webfDatetimepicker('close');
            $(this).trigger('change');
        },
        onTimeChange: function(date) {
            $(this).trigger('change');
            $(this).val(date.toString('dd/MM/yyyy HH:mm'));
        },
        buttons: {
            "Sans date": {
                cls: 'small primary',
                click: function() {
                    $(this).val('');
                    $(this).trigger('change');
                    $(this).webfDatetimepicker('close');
                }
            }
        }
    });

    $('.smart-date').each((i, input) => {
        $(input).webfDatetimepicker({
            showMonthYear: true,
            format: 'dd/MM/yyyy',
            timepicker: false,
            yearRange: 'c-120:c+10',
            onSelectDate: function() {
                $(this).trigger('change');
                $(this).webfDatetimepicker('close');
                $(this).trigger('change');
            },
            buttons: {
                "Sans date": {
                    cls: 'small primary',
                    click:  function() {
                        $(this).val('');
                        $(this).trigger('change');
                        $(this).webfDatetimepicker('close');
                    }
                }
            }
        });
    });

    $('.smart-date-seule').each((i, input) => {
        $(input).webfDatetimepicker({
            showMonthYear: true,
            format: 'dd/MM/yyyy',
            timepicker: false,
            yearRange: 'c-120:c+10',
            onSelectDate: function() {
                $(this).trigger('change');
                $(this).webfDatetimepicker('close');
                $(this).trigger('change');
            }
        });
    });

    /**
     * Checkboxes
     */
    $('.smart-input-checkbox').each((i, elem) => {
        const $form = $(elem).closest('form');
        if ($form.hasClass('nolabelforcheckboxes')) {
            if ($(elem).prop('id')) {
                const $label = $("label[for='" + $(elem).prop('id') + "']");

                if ($label[0]) {
                    $label.prop('for', '');
                }
            }
        }

        let style = 'switch';
        if ($(elem).hasClass('classic')) {
            style = 'classic';
        } else if ($(elem).hasClass('checkmark')) {
            style = 'checkmark';
        }

        // $(elem).webfCheckbox({
        //     classWrapper: 'smart-wrap-checkbox',
        //     style: style
        // });

        let classesWrapper = 'smart-wrap-checkbox';
        if ($(elem).hasClass('adjust-switch-1')) {
            classesWrapper += ' adjust-switch-1';
        } else if ($(elem).hasClass('adjust-switch-2')) {
            classesWrapper += ' adjust-switch-2';
        } else if ($(elem).hasClass('adjust-switch-3')) {
            classesWrapper += ' adjust-switch-3';
        } else if ($(elem).hasClass('adjust-switch-4')) {
            classesWrapper += ' adjust-switch-4';
        }

        $(elem).webfCheckbox({
            classWrapper: classesWrapper,
            style: style
        });
    });

    /**
     * Listes déroulantes
     */
    $('.smart-select-simple').webfSelect({
        width: '100%'
    });

    $('.smart-select-md-simple').each((i, select) => {
        $(select).webfSelect({
            width: '100%',
            behavior: 'MDSimple',
            inputMdClass: 'outlined',
            filter: !$(select).hasClass('noFilter')
        })
    });

    $('.smart-select-md-multiple').webfSelect({
        behavior: 'multiple',
        width: '100%'
    });

    eventDispatcher.dispatch('textarea-autogrow-update');
    eventDispatcher.dispatch('webf.tooltips-update');

    const selectorMDInputText = '.webf-md-textarea textarea, .webf-md-text input[type="text"], .webf-md-text.select-native select, .webf-md-text input[type="email"], .webf-md-text input[type="password"], .webf-md-text input[type="date"], .webf-md-text input[type="number"], .webf-md-text input[type="tel"]';
    $(selectorMDInputText).trigger('webf-init-md-text');

    $('input[type="text"]').each((i, input) => {
        const $input = $(input);

        if ($input.data('type') === 'number') {
            if ($input.val().length) {
                $input.val($input.val().replace('.', ','));
            }
        }
    })
});

eventDispatcher.addListener('webf.entity-open, textarea-autogrow-update', (eventName, elements) => {
    if (elements === undefined) {
        elements = $('textarea.autogrow');
    } else if (eventName === 'webf.entity-open') {
        elements = elements.find('textarea.autogrow');
    } else {
        elements = $(elements);
    }

    /**
     * Textareas autogrow
     */
    elements.each((i, textarea) => {
        if ($(textarea).is(':visible')) {
            autosize(textarea);
        }
    });
});

$(function () {
    $(document).on('click', '.webf-button.disabled', ev => ev.preventDefault());

    $('.flash-messages').each((i, elem) => {
        const type = $(elem).data('type');
        let delayClose = 7500;
        let autoClose = true;

        if (webf.inArray(type, ['warning', 'info'])) {
            delayClose = 15000;
        } else if (webf.inArray(type, ['danger'])) {
            autoClose = false;
        }

        $(elem).webfAlert({
            alertType: type,
            autoClose: autoClose,
            delayClose: delayClose,
            durationClose: 1000
        }).show();
    });

    $('.dialog-progress-upload').webfDialog({
        autoOpen: false,
        box: {
            header: {
                title: 'Upload du fichier',
                closeButton: false
            },
            footer: {
                closeButton: false
            }
        },
        onFirstOpen: ($e) => {
            if (!$e.find('.progressbar')[0]) {
                $e.append($('<div>').addClass('progressbar'));
            }
        }
    });

    eventDispatcher.dispatch('webf.refresh');

    $('select[readonly]').on('keydown mousedown click', (ev) => {
        ev.preventDefault();
    });

    if (webf.isTouchDevice()) {
        $('body').addClass('touchdevice');
    }

    $(document).on('input', 'input[type="text"]', (ev) => {
        const $input = $(ev.currentTarget);

        if ($input.data('type') === 'number') {
            const lastValue = $input.val();
            let newValue = lastValue.replace(/[^0-9\\.,-]/g, '');

            newValue = newValue
                .replace(/[,]+/g, ',')
                .replace(/[.]+/g, ',')
            ;

            if (newValue.split(',').length - 1 > 1) {
                let idxFirstComma = newValue.indexOf(',');
                let newValuePart1 = newValue.substr(0, idxFirstComma + 1);
                let newValuePart2 = newValue.substr(idxFirstComma + 1).replace(',', '');
                newValue = (newValuePart1 + '') + (newValuePart2 + '');
            }

            if (/^[^0-9,]/.test(newValue)) {
                newValue = newValue.substring(0);
            }

            if (newValue !== lastValue) {
                $input.val(newValue);
                ev.preventDefault();
            }
        }
    })

    tippyDelegate('body', {
        target: '[data-tippy-content]',
        delay: [300, 0],
        offset: [0, 5],
        theme: 'webf-tooltip'
    })

    $('.buttons-affichage').webfConnectedbuttons();

    window.addEventListener('handiphone:flic', (event) => {
        console.log('Flic reçu dans la WebView', event.detail)

        alert('Flic reçu !')
    })

    window.addEventListener('handiphone:flic', (event) => {
        console.log('Flic reçu dans la WebView', event.detail)
        alert('Flic reçu !')
    })


})
